var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-block',{staticClass:"no-padding"},[_c('DxForm',{attrs:{"id":"form","col-count":1}},[_c('DxSimpleItem',{attrs:{"data-field":_vm.$t('DxPostWorkEmployeeManualHarvesting_Kg'),"editor-type":"dxNumberBox","editor-options":{
        value: _vm.valueManualHarvesting,
        mode: 'number',
        width: 200,
        onValueChanged: _vm.setKgSelected,
        disabled: _vm.disableField,
      }}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }